import { Link, useLocation } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

// Define the navigation item interface
export interface NavigationItem {
    name: string;
    href: string;
    icon: LucideIcon;
}

// Define props interface for NavLinks component
interface NavLinksProps {
    mobile?: boolean;
    onItemClick?: () => void;
    navigation: NavigationItem[];
}

export const NavLinks = ({ mobile, onItemClick, navigation = [] }: NavLinksProps) => {
    const location = useLocation();

    return navigation.map((item) => {
        const isActive = location.pathname === item.href;
        const IconComponent = item.icon;

        return (
            <Link
                key={item.name}
                to={item.href}
                onClick={onItemClick}
                // Apply different styles based on active state and mobile/desktop view
                className={`flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors duration-200
                    ${isActive
                    ? 'bg-blue-800 text-white'
                    : 'text-blue-100 hover:bg-blue-800 hover:text-white'
                } ${mobile ? 'text-sm w-full' : ''}`}
            >
                <IconComponent className={`mr-2 h-4 w-4 flex-shrink-0 ${isActive ? 'text-white' : 'text-blue-300'}`} />
                <span className="truncate">{item.name}</span>
            </Link>
        );
    });
};

export default NavLinks;